import styles from "./OfferTerms.module.scss";

export const OfferTerms = ({ data }: any) => {
    return (
        <div className={`${styles.offerTermsContainer} ion-margin-horizontal ion-margin-top`}>
            <span className="font10 font500" dangerouslySetInnerHTML={{ __html: data?.descText }} ></span>
        </div>
    )
}